/**
 * Localized "Speaker" label for caption speaker lines (e.g. "Orador 1", "喇叭1").
 * Numbers are always kept as-is from the source payload.
 */
export const SPEAKER_LABELS = {
  en: "Speaker",
  ar: "المتحدث",
  bg: "Говорител",
  ca: "Orador",
  zh: "发言者",
  "zh-CN": "发言者",
  "zh-Hans": "发言者",
  "zh-TW": "講者",
  "zh-Hant": "講者",
  "zh-HK": "喇叭",
  cs: "Řečník",
  da: "Taler",
  "da-DK": "Taler",
  nl: "Spreker",
  "nl-BE": "Spreker",
  et: "Kõneleja",
  fi: "Puhuja",
  fil: "Tagapagsalita",
  fr: "Orateur",
  "fr-CA": "Orateur",
  de: "Sprecher",
  "de-CH": "Sprecher",
  el: "Ομιλητής",
  hi: "वक्ता",
  hu: "Előadó",
  is: "Ræðumaður",
  id: "Pembicara",
  it: "Relatore",
  ja: "話者",
  ko: "발표자",
  "ko-KR": "발표자",
  lv: "Runātājs",
  lt: "Kalbėtojas",
  ml: "പ്രസംഗകൻ",
  mr: "वक्ता",
  ms: "Penyampai",
  no: "Taler",
  pl: "Mówca",
  pt: "Orador",
  "pt-PT": "Orador",
  "pt-BR": "Palestrante",
  ro: "Vorbitor",
  ru: "Докладчик",
  sk: "Rečník",
  es: "Orador",
  "es-419": "Orador",
  sv: "Talare",
  "sv-SE": "Talare",
  th: "ผู้พูด",
  "th-TH": "ผู้พูด",
  tr: "Konuşmacı",
  uk: "Доповідач",
  vi: "Người nói",
};

export function resolveSpeakerLabel(langCode) {
  const code = langCode || "en";
  return (
    SPEAKER_LABELS[code] ||
    SPEAKER_LABELS[code.split("-")[0]] ||
    SPEAKER_LABELS.en
  );
}

/** Cantonese uses no space before the speaker number (e.g. 喇叭1). */
function usesCompactSpeakerNumber(langCode) {
  return langCode === "zh-HK";
}

function joinSpeakerLabel(label, num, langCode) {
  return usesCompactSpeakerNumber(langCode)
    ? `${label}${num}`
    : `${label} ${num}`;
}

/**
 * Format raw speaker id from the stream (e.g. "Speaker1") for display.
 */
export function formatSpeakerLabel(rawSpeaker, langCode = "en") {
  if (rawSpeaker == null || rawSpeaker === "") return rawSpeaker;
  const s = String(rawSpeaker).trim();
  const match =
    s.match(/^speaker\s*(\d+)$/i) || s.match(/^speaker(\d+)$/i);
  if (!match) return s;
  return joinSpeakerLabel(resolveSpeakerLabel(langCode), match[1], langCode);
}

/**
 * Localize an already-formatted English speaker line (e.g. "Speaker 1").
 */
export function localizeSpeakerDisplay(speakerLine, langCode = "en") {
  if (speakerLine == null || speakerLine === "") return speakerLine;
  const s = String(speakerLine).trim();
  const match = s.match(/^speaker\s*(\d+)$/i);
  if (!match) return s;
  return joinSpeakerLabel(resolveSpeakerLabel(langCode), match[1], langCode);
}


/** English speaker line for stored transcript HTML; localized at display time. */
export const formatSpeaker = (input) => formatSpeakerLabel(input, "en");
